import { RelatedEntityType } from "@dune/types";

export const getEntityLabel = (entityType: RelatedEntityType): string => {
	switch (entityType) {
		case RelatedEntityType.BROKER:
			return "Courtier";
		case RelatedEntityType.CONSTRUCTION_SITE:
			return "Chantier";
		case RelatedEntityType.PROPOSITION:
			return "Proposition";
		default:
			return entityType;
	}
};
